import React, { useEffect } from "react";
import DashboardButtons from "../Granja/DashboardButtons/DashboardButtons";
import { useShoppingContext } from "../context/ShoppingContext";

const Configuracion = () => {
  const { fetchAlimentos, fetchMisGalpones, fetchMisAves, isDarkMode } =
    useShoppingContext();
  useEffect(() => {
    // Fetch data for all sections on mount
    fetchAlimentos();
    fetchMisGalpones();
    fetchMisAves();
  }, [fetchAlimentos, fetchMisGalpones, fetchMisAves]);

  return (
    <div
      className={isDarkMode ? "content-container" : "content-container light"}
    >
      <DashboardButtons />

      {/* Controles para cambiar de sección */}
      {/* <div className="header-row">
        <button className="prev-button" onClick={prevSection}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
        <h2 className="title">{currentSection}</h2>
        <button className="next-button" onClick={nextSection}>
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div> */}

      {/* Renderizar la sección actual */}
      {/* <div className="section-content">{renderSection()}</div> */}
    </div>
  );
};

export default Configuracion;
